import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ISignInMagicLinkXP } from "@faire/web-api--source/indigofair/seo/ISignInMagicLinkXP";
import { ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024 } from "@faire/web-api--source/indigofair/settings/ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024";
import { ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024 } from "@faire/web-api--source/indigofair/settings/ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024";

export const useSettingMagicLinkProminenceXP = (): ISignInMagicLinkXP =>
  useSetting(
    ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024,
    ISignInMagicLinkXP.Bucket.CONTROL
  );

export const useAssignSettingMagicLinkProminenceXP = () =>
  useAssignSetting(
    ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024
  );

export const useSettingMFAExperienceXP = (): boolean =>
  useSetting(ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024, false);
